import { PixelPlaceholderLoader } from "@similarweb/ui-components";
import { StyledEnrichmentCarLoader } from "./styles";

const EnrichmentCardLoader = () => {
    return (
        <StyledEnrichmentCarLoader>
            <PixelPlaceholderLoader
                width={333}
                height={14}
            />
            <PixelPlaceholderLoader
                width={333}
                height={14}
            />
            <PixelPlaceholderLoader
                width={91}
                height={14}
            />
        </StyledEnrichmentCarLoader>
    );
};

export default EnrichmentCardLoader;
